import React, { useState, useEffect, useCallback } from "react";
import io from "socket.io-client";
import { requestListTruckView } from "../../services/trukSocket.services";
import { Box, Typography, useTheme, Button, Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText, Divider, CircularProgress, Alert } from "@mui/material";

import { tokens } from "../../theme";
import { DataGrid } from "@mui/x-data-grid";
import { format, set, setYear } from "date-fns";
import { getProduccionView, updateLavadora } from "../../services/lavadoraSocket.services";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import ReporteLavadora from "../../registration/reporteLavadora";
import { es } from "date-fns/locale";
import ModalLavadoraStar from "../../modal/lavadora start/modalLavadora";
import { getOneOrdenProduccionxd, getOrdenOne } from "../../services/ordenProduccion.services";
// import {  } from "../../services/ordenProduccion.services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getOne, putDescuentoStock} from "../../services/stock.services";
import VerticalShadesClosedIcon from '@mui/icons-material/VerticalShadesClosed';
import { getOneDatosCargadoraCab, getCargadoraCabPaquete } from "../../services/cargadora.services";
import ModalCharge from "../../modal/modalCharge";
import ModalSuccess from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import getUrlSocket from '../../utils/getUrlSocket';
import secureStorage from "../../utils/secureStorage";

const isEstadoEnProceso = (estado) => {
  if (estado === undefined || estado === null) {
    return false;
  }
  const normalized = String(estado).trim().toLowerCase();
  return (
    normalized === "1" ||
    normalized === "2" ||
    normalized === "en proceso" ||
    normalized === "en_proceso" ||
    normalized === "en-proceso"
  );
};

const SOCKET_URL = getUrlSocket();
const socket = io(SOCKET_URL, {
  withCredentials: true,
  transports: ["websocket", "polling"],
  query: {
    token: secureStorage.getItem("authToken"),
  },
});

const Lavadora = ({ onDataParseChange }) => {
  const [data, setData] = useState([]);
  const [dataParse, setParse] = useState({});
  const [filteredData, setFilteredData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [buttonEnable, setButtonEnable] = useState(true);
  const [buttonStop, setButtonStop] = useState(false);
  const [orderChange, setOrderChange] = useState(null);
  const [selectedCaballetes, setSelectedCaballetes] = useState([]);
  const [botonesDeshabilitados, setBotonesDeshabilitados] = useState(true); // Estado para desactivar botones
  const [isLoading, setIsLoading] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [error, setError] = useState("");
  const [toggle, setToggle] = useState(false);
  const [openPaquetes, setOpenPaquetes] = useState(false);
  const [paquetesDialogTitle, setPaquetesDialogTitle] = useState('');
  const [paquetesCaballete, setPaquetesCaballete] = useState([]);
  const [paquetesLoading, setPaquetesLoading] = useState(false);
  const [paquetesError, setPaquetesError] = useState("");


  const [updateStatus, setUpdateStatus] = useState({
    estado: 2,
  });

  const caballetesA = {
    car1A: 171,
    car2A: 173,
    car3A: 175,
  };

  const caballetesB = {
    car1B: 172,
    car2B: 174,
    car3B: 176,
  };

  const [paquetes, setPaquetes] = useState({ paqueteA: null, paqueteB: null });

  const handleOpenPaquetes = async (id, label) => {
    setPaquetesDialogTitle(`Visualizar paquetes - ${label}`);
    setPaquetesCaballete([]);
    setPaquetesError("");
    setOpenPaquetes(true);
    setPaquetesLoading(true);
    try {
      const data = await getCargadoraCabPaquete(id);
      let lista = [];
      if (Array.isArray(data)) {
        lista = data;
      } else if (data && typeof data === "object") {
        lista = [data];
      } else if (Array.isArray(data?.data)) {
        lista = data.data;
      } else if (data?.data && typeof data.data === "object") {
        lista = [data.data];
      } else if (Array.isArray(data?.items)) {
        lista = data.items;
      } else if (data?.items && typeof data.items === "object") {
        lista = [data.items];
      } else {
        lista = [];
      }
      setPaquetesCaballete(lista);
    } catch (e) {
      console.error("Error cargando paquetes del caballete:", e);
      setPaquetesCaballete([]);
      setPaquetesError("No se pudieron cargar los paquetes del caballete.");
      toast.error('No se pudieron cargar los paquetes del caballete.', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setPaquetesLoading(false);
    }
  };
  const handleClosePaquetes = () => setOpenPaquetes(false);


const handleCloseModalError = () => {
  setRegistrationError(false);
};
const handleCloseModalS = () => {
  setRegistrationSuccess(false);
  setButtonEnable(false);
  //  buttonEnabled(false); 
  setRegistrationSuccess(false);

  // resetForm();
};

  const [selectData, setSelectData] = useState({
    id: "",
    orden: "",
    cod: "",
    cantidad_total: "0",
    producidos: "0",
    Estado: "Seleccione una Orden",
    lote: "Seleccione una Orden",
    descripcion: "Seleccione una Orden",
    pvb: "Seleccione una Orden",
    create_at: "Seleccione una Orden",
    estado_calandra: 0
  });

useEffect(() => {
    socket.on('ProduccionUpdated', (data) => {
    console.log("🚀 ~ Lavadora ~ data:", data)

      if (data.response && data.response.orden) {
        const orden = data.response.orden;
        const paquete1 = secureStorage.getItem("paquete1")
        const paquete2 = secureStorage.getItem("paquete2")

        dataxd(orden)
        if (paquete1) {
          veririfyPaquete(paquete1);
        }

        if (paquete2) {
          veririfyPaquete(paquete2);
        }
      } else {
        console.warn("No se recibió una orden válida desde el socket.");
      }
    });
    return () => {
      socket.off('ProduccionUpdated');
    };
  }, []);


// Recuperar la orden guardada al cargar la página
useEffect(() => {
  const ordenGuardada = secureStorage.getItem("orden");
  const estadoGuardada = secureStorage.getItem("Estado");
  const toggleGuardado = secureStorage.getItem("toggle");

  if (!ordenGuardada) {
    return;
  }

  setSelectData((prevState) => ({
    ...prevState,
    orden: ordenGuardada || "",
  }));

  if (ordenGuardada !== "0" && isEstadoEnProceso(estadoGuardada)) {
    setButtonStop(true);
    setButtonEnable(false);
    // Restaurar el estado de toggle si hay una orden en proceso
    if (toggleGuardado === "true") {
      setToggle(true);
    }
  } else if (ordenGuardada === "0" || estadoGuardada === "0") {
    setButtonStop(false);
    setButtonEnable(true);
    setToggle(false);
    secureStorage.setItem("toggle", "false");
  }
}, []);

// Guardar la orden en localStorage cuando cambie dataParse
useEffect(() => {
  if (dataParse.orden) {
    secureStorage.setItem("orden", dataParse.orden);
    // secureStorage.setItem("estado_calandra", 0);
    // secureStorage.setItem("Estado", dataParse.Estado);

  }
}, [dataParse]);

// Actualizar dataParse cuando selectData cambia
useEffect(() => {
  setParse(selectData);
}, [selectData]);
  

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5 },
    {
      field: "orden",
      headerName: "Orden Produccion",
      flex: 0.5,
      cellClassName: "name-column--cell",
    },
    {
      field: "cod",
      headerName: "Producto",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "Estado",
      headerName: "Estado",
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },
  ];

  // Columnas para grid del modal de paquetes
  const paquetesColumns = [
    { field: 'cod', headerName: 'Producto', flex: 1, minWidth: 140 },
    { field: 'cod_interno', headerName: 'Codigo Interno', flex: 1, minWidth: 140 },
    { field: 'cantidad_entrada', headerName: 'Cantidad', flex: 0.6, minWidth: 120 },
    { field: 'serie', headerName: 'Serie', flex: 1, minWidth: 120 },
  ];


  useEffect(() => {
    // Si ambos paquetes son null, deshabilitar botones
    const deshabilitarBotones = paquetes.paqueteA === null && paquetes.paqueteB === null;
  
    // Actualizar estado de botones deshabilitados
    setBotonesDeshabilitados(deshabilitarBotones);
  
    // Forzar re-renderizado de los estilos de los botones
    if (deshabilitarBotones) {
      setSelectedCaballetes([]); // Vacía la selección para que los estilos se reseteen correctamente
    }
  }, [paquetes]); 
  


  useEffect(() => {
    const fetchData = async () => {
      const storedOrder = dataParse?.orden || secureStorage.getItem("orden");

      if (!storedOrder || storedOrder === "0") {
        fetchDataList();
        return;
      }

      try {
        const datos = await getOneOrdenProduccionxd(storedOrder);

        if (!datos) {
          return;
        }

        const lote = secureStorage.getItem("lote");

        setData((prev) => {
          const previous = Array.isArray(prev) ? prev : [];
          const others = previous.filter((item) => item?.id !== datos?.id);
          if (datos?.Estado === "concluido") {
            return others;
          }
          return [datos, ...others];
        });
        setSelectData((prevState) => ({
          ...prevState,
          ...datos,
          lote: lote ?? prevState.lote,
        }));

        if (isEstadoEnProceso(datos.Estado)) {
          secureStorage.setItem("Estado", "en proceso");
          setButtonEnable(false);
          setButtonStop(true);
          // Activar toggle cuando se recupera una orden en proceso
          const toggleGuardado = secureStorage.getItem("toggle");
          if (toggleGuardado === "true") {
            setToggle(true);
          }
        } else {
          const estadoValue = datos.Estado ?? "0";
          secureStorage.setItem("Estado", estadoValue);
          setButtonEnable(true);
          setButtonStop(false);
        }
      } catch (error) {
        console.error("Error al obtener datos del backend:", error);
      }
    };

    fetchData();
  }, [dataParse?.orden]);

    // Verifica el localStorage y obtiene la orden al cargar la página


  const handleToggle = () => {
    // Solo resetear toggle si NO hay una orden en proceso
    const estadoGuardada = secureStorage.getItem("Estado");
    if (!isEstadoEnProceso(estadoGuardada)) {
      setToggle(false);
      secureStorage.setItem("toggle", "false");
    }
  };


  const handleRowDoubleClick = useCallback((params) => {
    const selectedOrden = params.row;
    // Solo resetear toggle si NO hay una orden en proceso
    const estadoGuardada = secureStorage.getItem("Estado");
    if (!isEstadoEnProceso(estadoGuardada)) {
      secureStorage.setItem("toggle", "false");
      setToggle(false);
    }
    // Extraer y formatear la fecha
    const { create_at, orden, Estado} = selectedOrden;
    const formattedDate = format(new Date(create_at), "dd/MM/yyyy-HH:mm", {
      locale: es,
    });
    const lote = `${orden}-${formattedDate}`;
    secureStorage.setItem("lote", lote);
    // Actualizar el estado
    setSelectData((prevState) => ({
      ...prevState, // Mantener valores existentes
      ...selectedOrden, // Agregar/actualizar valores provenientes de la fila seleccionada
      create_at: formattedDate, // Sobrescribir `create_at` con la fecha formateada
      lote,
      Estado:1,
      estado_calandra:0,
      // pvb:0
    }));
    

  }, []);



  useEffect(() => {
   
    const dataToParse =  () => {
      setParse(selectData)
    }
    dataToParse();
    
  }, [selectData])
  


  const handleButtonStatus = (value) => {
    setButtonEnable(value); // Guardar el valor en el estado
  };


  const handleOrderChange = (value) => {
    setOrderChange(value); // Guardar el valor en el estado
  };
  // Calcular el progreso como porcentaje
  const progress = (selectData.producidos / selectData.cantidad_total) * 100;




  const dataxd = async (orden) => {
    if(orden){
      const datos = await getOrdenOne(orden);
      setSelectData(prevState => ({
        ...prevState,
        producidos: parseInt(datos.producidos),
        cantidad_total: parseInt(datos.cantidad_total),
        Estado: datos.Estado
      }));
      
      // Actualizar también el estado en el DataGrid
      setData(prevData => {
        return prevData.map(item => {
          if (item.orden === orden) {
            return {
              ...item,
              Estado: datos.Estado,
              producidos: parseInt(datos.producidos),
              cantidad_total: parseInt(datos.cantidad_total)
            };
          }
          return item;
        });
      });
    }

  }



  const fetchData = async () => {
    try {
      const datos = await getProduccionView();

      const filteredData = datos.filter((item) => item.Estado !== "concluido");
      setData(filteredData);
    } catch (error) {
      console.error("Error al obtener datos del backend:", error);
    }
  };

  useEffect(() => {
    fetchData();

  }, []);

  const handleModal = async () => {
     if( selectData.orden === "" || selectData.orden === "0" ){
      toast.error(
        `¡Primero debes Seleccionar una Orden!`,
        {
          position: "top-center",
          autoClose: 9000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      return;
    }else if(paquetes.paqueteA === "" || paquetes.paqueteA === null ){
      toast.error(
        `Seleccione los paquetes para continuar.`,
        {
          position: "top-center",
          autoClose: 9000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      return;
    }


const llaveMaestra = secureStorage.getItem("llave");
const xdllave = parseInt(llaveMaestra);
  //  setIsOpen(true)
  //  onSelectOrden("Orden123")
const objectToSend = {
  Estado: 2,
  caballete1: paquetes.paqueteA,
  caballete2: paquetes.paqueteB,
  caballete3:"0",
  caballete4:"0",
  cantidad_total: selectData.cantidad_total,
  cod: selectData.cod,
  estado_calandra: 0,
  orden: selectData.orden,
  llave:xdllave,
}

 try {
    setIsLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const valuesxd = (objectToSend);
      const response = await updateLavadora(dataParse.orden, valuesxd);

      const resp = response?.response ?? response;
      if (!resp?.ok) {
        const detalleChapas = resp?.chapasNecesarias
          ? ` (Requeridas: ${resp.chapasNecesarias.chapa_tipo_1 || '-'} y ${resp.chapasNecesarias.chapa_tipo_2 || '-'})`
          : '';
        const msg = resp?.error || resp?.mensajeChapas || 'No se pudo iniciar la orden.';
        toast.error(`${msg}${detalleChapas}`, {
          position: "top-center",
          autoClose: 9000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setRegistrationError(true);
        setError(`${msg}${detalleChapas}`);
        return;
      }

      setToggle(true);
            // Si paquete1 es inválido, usa paquete2
            if (!paquetes.paqueteA?.trim() && paquetes.paqueteB?.trim()) {
              paquetes.paqueteA = paquetes.paqueteB;
              } else if (!paquetes.paqueteB?.trim() && paquetes.paqueteA?.trim()) {
              paquetes.paqueteB = paquetes.paqueteA;
              }
              
              secureStorage.setItem("paquete1", paquetes.paqueteA ?? "");
              secureStorage.setItem("paquete2", paquetes.paqueteB ?? "");
       secureStorage.setItem("toggle", "true");
       secureStorage.setItem("cod", selectData.cod);
       secureStorage.setItem("cantidad_total", selectData.cantidad_total);


              secureStorage.setItem("Estado", "en proceso");
      setRegistrationSuccess(true); // O cualquier otra acción que debas tomar
      setButtonEnable(false);
              setButtonStop(true);
      setTimeout(() => {
        handleCloseModal();
      }, 1000);
    } catch (error) {
      console.error("error sending data", error);
      setRegistrationError(true);
      setError(error.message);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }


  }

  
  const handlePause = async () => {
    const ordenActual = secureStorage.getItem("orden");
    const estadoActual = secureStorage.getItem("Estado");
    const palanca = JSON.parse(secureStorage.getItem("toggle") || "false");

    // Verificar si hay una orden activa en proceso
    // Se considera activa si: el botón Stop está habilitado O el toggle está activo O el estado es en proceso
    const hayOrdenActiva = buttonStop || toggle || palanca || isEstadoEnProceso(estadoActual);

    if (!hayOrdenActiva) {
      toast.error(
        `¡Primero debes Seleccionar una Orden!`,
        {
          position: "top-center",
          autoClose: 9000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      return;
    }

    // Verificar que la orden no sea "0" o vacía
    if (!ordenActual || ordenActual === "0") {
      toast.error(
        `¡No hay una orden válida para detener!`,
        {
          position: "top-center",
          autoClose: 9000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      return;
    }

    await handleUpdate();
    handleButtom();
    setButtonEnable(true);
    setParse({});

    setData([]); // Limpia los datos para no renderizar nada
    fetchDataList();

    // Establecer la orden como "0" en localStorage y en el estado
    secureStorage.setItem("Estado", "0");
    secureStorage.setItem("estado_calandra", "0");
    secureStorage.setItem("orden", "0");
    secureStorage.setItem("pvb", "");
    secureStorage.setItem("paquete1", "");
    secureStorage.setItem("paquete2", "");
    secureStorage.setItem("selectedCaballetes", "");
    secureStorage.setItem("toggle", "false");
    setSelectedCaballetes([]);
    setPaquetes({ paqueteA: null, paqueteB: null });
    setSelectData((prevState) => ({ ...prevState, orden: "0" }));
  
    // Evitar renderizado adicional estableciendo estados pertinentes
    setToggle(false);
  };
  
  
// const handleUpdate = async () => {
//     // setIsLoading(true);

//   try {
//     await new Promise((resolve) => setTimeout(resolve, 1000));
//    const valuesxd = ({...selectData, estado_calandra:0});
//   //  const ordenGuardada = secureStorage.getItem("orden");
//   //  const EstadoGuardada = secureStorage.getItem("Estado");
//   //  const EstadoCalandra = secureStorage.getItem("estado_calandra");
  
//   //  const valuesdx = {
//   //   EstadoCalandra,
//   //   EstadoGuardada
//   //  }
//   //  if (ordenGuardada) {
//   //   const response = await updateLavadora(ordenGuardada, valuesdx);
//   //   }else{
//   //   const response = await updateLavadora(dataParse.orden, valuesxd);

//   //   }
//     const response = await updateLavadora(dataParse.orden, valuesxd);
//     secureStorage.setItem("paquete1", paquetes.paqueteA);
//     secureStorage.setItem("paquete2", paquetes.paqueteB);


//     // setButtonEnable(true);
//     fetchDataList();
//     setSelectData({
//       id: "",
//       orden: "",
//       cod: "",
//       cantidad_total: "0",
//       producidos: "0",
//       Estado: "Seleccione una Orden",
//       lote: "Seleccione una Orden",
//       descripcion: "Seleccione una Orden",
//       pvb: "Seleccione una Orden",
//       create_at: "Seleccione una Orden",
//     })
//     // setRegistrationSuccess(true);
//   } catch (error) {
    
//   }
// }



const handleUpdate = async () => {

  try {
    
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const valuesxd = { ...selectData, Estado: 1, estado_calandra: 0, pvb: 0, chapa1:"", chapa2:"" };
    const response = await updateLavadora(dataParse.orden, valuesxd);

    fetchDataList();

    setSelectData({
      id: "",
      orden: "",
      cod: "",
      cantidad_total: "0",
      producidos: "0",
      Estado: "Seleccione una Orden",
      lote: "Seleccione una Orden",
      descripcion: "Seleccione una Orden",
      pvb: "Seleccione una Orden",
      create_at: "Seleccione una Orden",
    });
  } catch (error) {
    console.error("Error al actualizar:", error);
  }
  setToggle(false);
  secureStorage.setItem("toggle", "false");
};

// useEffect(() => {
//   if (toggle) {
//  setToggle(true);
//   }
// }, [handleUpdate]);

useEffect(() => {
  const handleStorageChange = () => {
    setPaquetes({
      paqueteA: secureStorage.getItem("paquete1"),
      paqueteB: secureStorage.getItem("paquete2"),
    });
  };

  window.addEventListener("storage", handleStorageChange);

  return () => {
    window.removeEventListener("storage", handleStorageChange);
  };
}, []);

  const handleButtom =  () => {
   setButtonStop(false);
  }

   useEffect(() => {
    if(buttonEnable === false){
      setButtonStop(true);
    
    } else if (buttonEnable === true){
      setButtonStop(false);
    }
 
   }, [buttonEnable])
   

  //  useEffect(() => {
  //  setSelectData()
  //  }, [buttonEnable])
   
  useEffect(() => {
    const ordenGuardada = secureStorage.getItem("orden");
    if (ordenGuardada === "0") {
      fetchDataList();
    }
  }, []);

   const fetchDataList = async () => {
    try {
      const datos = await getProduccionView();

      if (datos) {
        const filteredData = datos.filter((item) => item.Estado !== "concluido");
        setData(filteredData);
        //  setButtonEnable(false);
        // setButtonStop(false);
      }
    } catch (error) {
      console.error("Error al obtener datos del backend:", error);
    }
  };


  const HandleCargadoraPaquete = async (cab) => {
    try {
      const response = await getOneDatosCargadoraCab(cab);
      return response?.cod_interno || null;
    } catch (error) {
      console.error("Error al obtener datos del backend:", error);
      return null;
    }
  };


  const veririfyPaquete = async (paquete) => {
    const response = await getOne(paquete);
    if(response.cantidad_entrada==0){
      toast.error(
        `Paquete ${response.cod_interno} tiene ${response.cantidad_entrada} chapas, Registrar nuevo Paquete.`,
        {
          position: "top-center",
          autoClose: 9000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      try {
        const data = { id_caballete: 228 };
        const update = await putDescuentoStock(response.id, data);
      } catch (error) {
        console.error("Error al actualizar el stock:", error);
      }
      await new Promise((resolve) => setTimeout(resolve, 1000));
      getPaquete();

     
    }
  }




const handleUpdatePaquete = async () => {

  // Verificar si los valores necesarios están presentes
  if (!selectData.cantidad_total || !selectData.cod) {
    console.error("Faltan valores en selectData:", selectData);
    toast.error("No se pueden enviar paquetes. Verifica los datos seleccionados.", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
    return;
  }

  const paq1 = secureStorage.getItem("paquete1");
  const paq2 = secureStorage.getItem("paquete2");
  const orden = secureStorage.getItem("orden");
  const ordeni = parseInt(orden);
  const codd = secureStorage.getItem("cod");
  const cantidad_total = secureStorage.getItem("cantidad_total");

  const objectToSend = {
    Estado: 2,
    caballete1: paq1,
    caballete2: paq2,
    caballete3: "0",
    caballete4: "0",
    cantidad_total: cantidad_total,
    cod: codd,
    estado_calandra: 0,
    orden: ordeni,
    pvb:0
  };


  try {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    const response = await updateLavadora(dataParse.orden, objectToSend);

    const resp = response?.response ?? response;
    if (!resp?.ok) {
      const detalleChapas = resp?.chapasNecesarias
        ? ` (Requeridas: ${resp.chapasNecesarias.chapa_tipo_1 || '-'} y ${resp.chapasNecesarias.chapa_tipo_2 || '-'})`
        : '';
      const msg = resp?.error || resp?.mensajeChapas || 'No se pudo actualizar paquetes.';
      toast.error(`${msg}${detalleChapas}`, {
        position: "top-center",
        autoClose: 9000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setRegistrationError(true);
      setError(`${msg}${detalleChapas}`);
      return;
    }

    setToggle(true);

    // Actualizar localStorage con los paquetes
    if (!paquetes.paqueteA?.trim()) paquetes.paqueteA = paquetes.paqueteB;
    if (!paquetes.paqueteB?.trim()) paquetes.paqueteB = paquetes.paqueteA;

    secureStorage.setItem("paquete1", paquetes.paqueteA);
    secureStorage.setItem("paquete2", paquetes.paqueteB);
    secureStorage.setItem("toggle", true);
    secureStorage.setItem("Estado", "en proceso");

    setRegistrationSuccess(true);
    setButtonEnable(false);
    setButtonStop(true);

    setTimeout(() => {
      handleCloseModal();
    }, 1000);
  } catch (error) {
    console.error("Error al enviar paquetes:", error);
    setRegistrationError(true);
    setError(error.message);
  } finally {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }
};

const getPaquete = async () => {
  const selectedCaballetes = JSON.parse(secureStorage.getItem("selectedCaballetes") || "[]");

  const caballete1 = selectedCaballetes[0];
  const caballete2 = selectedCaballetes[1];

  const resp = await HandleCargadoraPaquete(caballete1);
  const resp2 = await HandleCargadoraPaquete(caballete2);

  secureStorage.setItem("paquete1", resp);
  secureStorage.setItem("paquete2", resp2);

  setPaquetes({
    paqueteA: resp,
    paqueteB: resp2,
  });

  // Llamar a handleUpdatePaquete después de actualizar los paquetes
  handleUpdatePaquete();

}
  
  const handleCloseModal = () => {
    setIsOpen(false);
    // resetForm();
  };


  const getRowClassName = (params) => {
    const estado = params.row.Estado;
    switch (estado) {
      case "programado":
        return "estado-pendiente";
      case "concluido":
        return "estado-completo";
      case "en proceso":
        return "estado-en-proceso";
      default:
        return "estado-default";
    }
  };
  


  useEffect(() => {
    const fetchData = async () => {
      try {
        const ordenGuardada = secureStorage.getItem("orden") ;
        if (ordenGuardada != "0") {
          const datos = await getOneOrdenProduccionxd(ordenGuardada);
            if (datos) {
              setData((prev) => {
                const previous = Array.isArray(prev) ? prev : [];
                const others = previous.filter((item) => item?.id !== datos?.id);
                if (datos?.Estado === "concluido") {
                  return others;
                }
                return [datos, ...others];
              });
            if (isEstadoEnProceso(datos.Estado)) {
              setButtonStop(true);
              setButtonEnable(false);
              secureStorage.setItem("Estado", "en proceso");
            } else {
              setButtonStop(false);
              setButtonEnable(true);
              secureStorage.setItem("Estado", datos.Estado ?? "0");
            }
          }


        }else if (ordenGuardada === null || ordenGuardada === undefined) {
        } 
      } catch (error) {
        console.error("Error al obtener datos del backend:", error);
      }
    };

    if (dataParse.orden === null || dataParse.orden === undefined) {
    }else{
      fetchData(); 
    }
  
  }, []);

  useEffect(() => {
    const storedCaballetes = secureStorage.getItem("selectedCaballetes");
    if (storedCaballetes) {
      setSelectedCaballetes(JSON.parse(storedCaballetes));
    }
  }, []);
  

  const handleSelectCaballetes = async (cab) => {
    setSelectedCaballetes((prev) => {
      let updatedCaballetes = [...prev];
  
      // Si el caballete ya está seleccionado, lo eliminamos
      if (updatedCaballetes.includes(cab)) {
        updatedCaballetes = updatedCaballetes.filter((c) => c !== cab);
  
        // Reiniciar paquetes a null cuando se deselecciona cualquier caballete
        setPaquetes({ paqueteA: null, paqueteB: null });
  
        // Desactivar botones cuando los paquetes se vuelvan null
        setBotonesDeshabilitados(true);
  
        // Si no hay caballetes seleccionados, limpiar el localStorage
        if (updatedCaballetes) {
          secureStorage.removeItem("selectedCaballetes");
        } else {
          secureStorage.setItem("selectedCaballetes", JSON.stringify(updatedCaballetes));
        }
  
        return updatedCaballetes;
      }
  
      // Si ya hay 2 caballetes seleccionados, no permitir más
      if (updatedCaballetes.length >= 2) {
        console.log("No puedes seleccionar más de 2 caballetes. Primero deselecciona uno.");
        return prev;
      }
  
      // Agregar el nuevo caballete
      updatedCaballetes.push(cab);
  
      // Guardar en localStorage
      secureStorage.setItem("selectedCaballetes", JSON.stringify(updatedCaballetes));
  
      // Obtener paquete del backend y actualizar correctamente
      HandleCargadoraPaquete(cab).then((paquete) => {
        setPaquetes((prevPaquetes) => {
          const nuevoPaqueteA = prevPaquetes.paqueteA === null ? paquete : prevPaquetes.paqueteA;
          const nuevoPaqueteB = prevPaquetes.paqueteA !== null && prevPaquetes.paqueteB === null ? paquete : prevPaquetes.paqueteB;
  
          // Activar botones solo si hay al menos un paquete seleccionado
          setBotonesDeshabilitados(nuevoPaqueteA === null && nuevoPaqueteB === null);
  
          return { paqueteA: nuevoPaqueteA, paqueteB: nuevoPaqueteB };
        });
      });
  
      return updatedCaballetes;
    });
  };


  return (
    // container
    <Box
      sx={{
        background: "#111830",
        height: "96vh",
        width: "98%",
        padding: "3vh 5vw",
        marginTop: "2vh",
        marginLeft: "1vw",
        // boxShadow: "0 0 5px 0px #000000",
        borderRadius: "10px",
        boxSizing: "border-box",
      }}
    >
      {/* container flex */}
      <Box
        sx={{
          display: "flex",
          height: "102%",
          width: "109%",
          marginLeft: "-4vw",
        }}
      >
        <Box
          sx={{
            background: "#242b43",
            // background:"#111830",
            width: "99%",
            height: "92vh",
            marginRight: "0.9vw",
          }}
        >
          <Box
            sx={{
              height: "10vh",
              width: "47vw",
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "1.5%",
            }}
          >
            <Box sx={{ display: "flex" }}>
              <Typography
                variant="h1"
                sx={{
                  fontSize: "2.2vw",
                  marginLeft: "1vh",
                  marginTop: "2vh",

                  fontWeight: "600",
                  textShadow: "2px 2px 2px black",
                }}
              >
                {/* Camión: {filteredData.chapa} */}
                Orden de Produccion N°:
              </Typography>

              <Typography
                variant="h1"
                sx={{
                  fontSize: "2.2vw",
                  marginLeft: "1vh",
                  marginTop: "2vh",
                  fontWeight: "600",
                  color: "rgb(206, 220, 0)",
                  textShadow: "2px 2px 2px black",
                }}
              >
                {selectData.orden}
              </Typography>
            </Box>

            <Typography
              variant="h1"
              sx={{
                fontSize: "2.2vw",
                marginRight: "2.5vh",
                fontWeight: "600",
                textShadow: "2px 2px 2px black",
                marginTop: "2vh",
              }}
            >
              {/* Camión: {filteredData.chapa} */}
              Cargadora
            </Typography>
          </Box>

          <Box
            sx={{
              height: "30vh",
              width: "45vw",
              background: "#2a324d",
              margin: "auto",
              marginTop: "3vh",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: "1.5vw",
                marginLeft: "1vh",
                paddingTop: "2vh",

                fontWeight: "600",
                textShadow: "2px 2px 2px black",
              }}
            >
              {selectData.cod}
            </Typography>

            <Box sx={{ display: "flex" }}>
              <Typography
                variant="h1"
                sx={{
                  fontSize: "1.5vw",
                  marginLeft: "1vh",
                  fontWeight: "600",
                  textShadow: "2px 2px 2px black",
                  paddingTop: "2vh",
                }}
              >
                {/* Camión: {filteredData.chapa} */}
                LOTE:
              </Typography>

              <Typography
                variant="h1"
                sx={{
                  fontSize: "1.5vw",
                  marginLeft: "1vh",
                  paddingTop: "2vh",
                  fontWeight: "600",
                  color: "rgb(206, 220, 0)",
                  textShadow: "2px 2px 2px black",
                }}
              >
                {selectData.lote }
              </Typography>
            </Box>

            <Box sx={{ display: "flex" }}>
              <Typography
                variant="h1"
                sx={{
                  fontSize: "1.5vw",
                  marginLeft: "1vh",
                  paddingTop: "2vh",
                  fontWeight: "600",
                  textShadow: "2px 2px 2px black",
                }}
              >
                {/* Camión: {filteredData.chapa} */}
                CHAPA:
              </Typography>

              <Typography
                variant="h1"
                sx={{
                  fontSize: "1.5vw",
                  marginLeft: "1vh",
                  paddingTop: "2vh",
                  fontWeight: "600",
                  color: "rgb(206, 220, 0)",
                  textShadow: "2px 2px 2px black",
                }}
              >
                {/* Camión: {filteredData.chapa} */}
                {selectData.producidos}
              </Typography>

              <Typography
                variant="h1"
                sx={{
                  fontSize: "1.5vw",
                  marginLeft: "1vh",
                  paddingTop: "2vh",
                  fontWeight: "600",
                  textShadow: "2px 2px 2px black",
                }}
              >
                {/* Camión: {filteredData.chapa} */}/
              </Typography>

              <Typography
                variant="h1"
                sx={{
                  fontSize: "1.5vw",
                  marginLeft: "1vh",
                  paddingTop: "2vh",
                  fontWeight: "600",
                  color: "rgb(206, 220, 0)",
                  textShadow: "2px 2px 2px black",
                }}
              >
                {/* Camión: {filteredData.chapa} */}
                {selectData.cantidad_total}
              </Typography>
            </Box>

            <Typography
              variant="h2"
              sx={{
                fontSize: "1.5vw",
                marginLeft: "1vh",
                paddingTop: "2vh",

                fontWeight: "600",
                textShadow: "2px 2px 2px black",
              }}
            >
              {selectData.descripcion}
            </Typography>

            <Typography
              variant="h2"
              sx={{
                fontSize: "1.5vw",
                marginLeft: "1vh",
                paddingTop: "2vh",
                fontWeight: "600",
                textShadow: "2px 2px 2px black",
              }}
            >
              {selectData.pvb}
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "10%",
              // background:"red"
              paddingLeft: "2vw",
              margin: "1.5vh",
              paddingTop: "1vh",
            }}
          >
            <Button
              onClick={handleModal}
              disabled={!buttonEnable}
              sx={{
                backgroundColor: buttonEnable ? "rgb(206, 220, 0)" : "gray",
                border: "none",
                color: buttonEnable ? "black" : "white",
                height: "6vh",
                width: "20vw",
                borderRadius: "20px",
                cursor: buttonEnable ? "pointer" : "not-allowed",
                marginRight: "2vw",

                "&:hover": {
                  backgroundColor: buttonEnable ? "#bac609" : "gray",
                },
              }}
            >
              {" "}
              Iniciar{" "}
            </Button>{" "}
            <Button
              disabled={!buttonStop}
              onClick={handlePause}
              sx={{
                background: buttonStop ? "#740017" : "#49232a",
                border: "none",
                color: "white",
                height: "6vh",
                width: "20vw",
                borderRadius: "20px",
                cursor: "pointer",
                "&:hover": { backgroundColor: "#a00423" },
              }}
            >
              {" "}
              Detener{" "}
            </Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginTop: "-2vh",
              marginBottom: "3vh",
            }}
          >
            <Box
              sx={{
                width: "100%",
                mr: 2,
                paddingLeft: "1vw",
                paddingTop: "1vw",
              }}
            >
              <LinearProgress
                variant="determinate"
                value={progress}
                sx={{
                  height: "25px", // Altura de la barra
                  borderRadius: "5px",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: "rgb(206, 220, 0)",
                  },
                }}
              />
            </Box>

            <Box sx={{ minWidth: 50 }}>
              <Typography
                variant="body1"
                sx={{ color: "white", fontWeight: "bold", paddingTop: "1vw" }}
              >
                {`${Math.round(progress)}%`}
              </Typography>
            </Box>
          </Box>

          {/* xd */}

          <Box
            sx={{
              height: "20vh",
              width: "45vw",
              background: "#2a324d",
              margin: "auto",
              marginTop: "1vh",
              display: "flex",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
                justifyContent: "center",
                height: "30.5vh",
                width: "45vw",
                background: "#2a324d",

                marginTop: "0vh",
              }}
            >
              
              <Box sx={{ display:'flex', alignItems:'center', gap:2, mt:2 }}>
                {/* Botón visualizar paquetes - lado A */}
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleOpenPaquetes(caballetesA.car1A, 'CAB1A')}
                  sx={{ color: "#fff", borderColor: "#bac609", height:'4vh', marginLeft:'1vw' }}
                >
                  Visualizar paquetes
                </Button>
                <Button
                  type="submit"
                  onClick={() => handleSelectCaballetes(caballetesA.car1A)}
                  sx={{
                    border: "none",
                    color: "white",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    cursor: "pointer",
                    marginLeft: "0vw",
                  }}
                  endIcon={
                    <VerticalShadesClosedIcon
                      sx={{
                        fontSize: "8vh!important",
                        border:
                          selectedCaballetes.includes(caballetesA.car1A)
                            ? "2px solid #bac609"
                            : "none",
                      }}
                    />
                  }
                >
                  CAB1A
                </Button>
              </Box>

              {/* Fila CAB2A - lado A */}
              <Box sx={{ display:'flex', alignItems:'center', gap:2, mt:2 }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleOpenPaquetes(caballetesA.car2A, 'CAB2A')}
                  sx={{ color: "#fff", borderColor: "#bac609", height:'4vh', marginLeft:'1vw' }}
                >
                  Visualizar paquetes
                </Button>
                <Button
                  type="submit"
                  onClick={() => handleSelectCaballetes(caballetesA.car2A)}
                  sx={{
                    // backgroundColor: "rgb(206, 220, 0)",
                    border: "none",
                    color: "white",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    cursor: "pointer",
                    marginTop: "0",
                    

                    // "&:hover": { backgroundColor: "#bac609" },
                  }}
                  endIcon={
                    <VerticalShadesClosedIcon
                      sx={{
                        fontSize: "8vh!important",
                        border:
                          
                          selectedCaballetes.includes(caballetesA.car2A)
                            ? "2px solid #bac609"
                            : "none",
                            
                      }}
                    />
                  }
                >
                  CAB2A
                </Button>
              </Box>

              {/* Fila CAB3A - lado A */}
              <Box sx={{ display:'flex', alignItems:'center', gap:2, mt:2 }}>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleOpenPaquetes(caballetesA.car3A, 'CAB3A')}
                  sx={{ color: "#fff", borderColor: "#bac609", height:'4vh', marginLeft:'1vw' }}
                >
                  Visualizar paquetes
                </Button>
                <Button
                  type="submit"
                  onClick={() => handleSelectCaballetes(caballetesA.car3A)}
                  sx={{
                    border: "none",
                    color: "white",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    cursor: "pointer",
                    marginTop: "0",
                  }}
                  endIcon={
                    <VerticalShadesClosedIcon
                      sx={{
                        fontSize: "8vh!important",
                        border:
                          selectedCaballetes.includes(caballetesA.car3A)
                            ? "2px solid #bac609"
                            : "none",
                      }}
                    />
                  }
                >
                  CAB3A
                </Button>
              </Box>


            </Box>

            {/* cargadora */}
            <Box
              sx={{
                height: "29.5vh",
                width: "45vw",
                background: "#2a324d",
                // margin: "auto",
                marginTop: "1vh",
                // display: "flex",
              }}
            >
              <img
                src="../../assets/cargadora.png"
                style={{
                  width: "60%",
                  height: "110%",
                  marginTop: "-3vh",
                  marginLeft: "2.8vw",
                }}
              ></img>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                justifyContent: "center",
                height: "30.5vh",
                width: "45vw",
                background: "#2a324d",

                marginTop: "0vh",
              }}
            >
              {/* Fila CAB1B - lado B */}
              <Box sx={{ display:'flex', alignItems:'center', gap:2, mt:2 }}>
                <Button
                  type="submit"
                  onClick={() => handleSelectCaballetes(caballetesB.car1B)}
                  sx={{
                    border: "none",
                    color: "white",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    cursor: "pointer",
                    marginTop: "0",
                  }}
                  startIcon={
                    <VerticalShadesClosedIcon
                      sx={{
                        marginLeft: "-3vw",
                        fontSize: "8vh!important",
                        border:
                          selectedCaballetes.includes(caballetesB.car1B)
                            ? "2px solid #bac609"
                            : "none",
                      }}
                    />
                  }
                >
                  CAB1B
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleOpenPaquetes(caballetesB.car1B, 'CAB1B')}
                  sx={{ color: "#fff", borderColor: "#bac609", height:'4vh', marginRight:'1vw' }}
                >
                  Visualizar paquetes
                </Button>
              </Box>

              {/* Fila CAB2B - lado B */}
              <Box sx={{ display:'flex', alignItems:'center', gap:2, mt:2 }}>
                <Button
                  type="submit"
                  onClick={() => handleSelectCaballetes(caballetesB.car2B)}
                  sx={{
                    border: "none",
                    color: "white",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    cursor: "pointer",
                    marginTop: "0",
                  }}
                  startIcon={
                    <VerticalShadesClosedIcon
                    sx={{
                      marginLeft: "-3vw",
                      fontSize: "8vh!important",
                      border:
                        selectedCaballetes.includes(caballetesB.car2B)
                          ? "2px solid #bac609"
                          : "none",
                    }}
                    />
                  }
                >
                  CAB2B
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleOpenPaquetes(caballetesB.car2B, 'CAB2B')}
                  sx={{ color: "#fff", borderColor: "#bac609", height:'4vh', marginRight:'1vw' }}
                >
                  Visualizar paquetes
                </Button>
              </Box>

              {/* Fila CAB3B - lado B */}
              <Box sx={{ display:'flex', alignItems:'center', gap:2, mt:2 }}>
                <Button
                  type="submit"
                  onClick={() => handleSelectCaballetes(caballetesB.car3B)}
                  sx={{
                    border: "none",
                    color: "white",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    cursor: "pointer",
                    marginTop: "0",
                  }}
                  startIcon={
                    <VerticalShadesClosedIcon
                    sx={{
                      marginLeft: "-3vw",
                      fontSize: "8vh!important",
                      border:
                        selectedCaballetes.includes(caballetesB.car3B)
                          ? "2px solid #bac609"
                          : "none",
                    }}
                    />
                  }
                >
                  CAB3B
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleOpenPaquetes(caballetesB.car3B, 'CAB3B')}
                  sx={{ color: "#fff", borderColor: "#bac609", height:'4vh', marginRight:'1vw' }}
                >
                  Visualizar paquetes
                </Button>
              </Box>

            </Box>
          </Box>
        </Box>

        {/* container 2 */}
        <Box
          sx={{
            background: "#111830",
            width: "100%",
            height: "99%",
            // display:"flex"
            borderTop: "3px solid #242b43",
            position: "relative", // Establece un contexto de posición para el z-index
            zIndex: 10, // Define un nivel base
          }}
        >
          <Box
            m="10px 0 0 0"
            height="45.5vh"
            sx={{
              "& .MuiDataGrid-root": {
                position: "relative",
                border: "none",
                zIndex: 100,
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "none",
              },
              "& .name-column--cell": {
                color: colors.greenAccent[300],
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: colors.blueAccent[900],
                borderBottom: "none",
              },
              "& .MuiDataGrid-virtualScroller": {
                backgroundColor: colors.primary[400],
              },
              "& .MuiDataGrid-footerContainer": {
                borderTop: "none",
                backgroundColor: colors.blueAccent[900],
              },
              "& .MuiCheckbox-root": {
                color: `${colors.greenAccent[200]} !important`,
              },
              "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                color: `${colors.grey[100]} !important`,
              },
              // Estilos para las filas con hover
              "& .estado-pendiente": {
                backgroundColor: "#740017", // Color de texto
                textShadow: "2px 2px 2px 2px #ffffff",
                "&:hover": {
                  backgroundColor: "rgb(27 33 54) !important", // Fondo al pasar el ratón
                },
              },
              "& .estado-completo": {
                backgroundColor: "green",
                textShadow: "2px 2px 2px 2px #ffffff",
                "&:hover": {
                  backgroundColor: "rgb(27 33 54) !important", // Fondo al pasar el ratón
                },
              },
              "& .estado-en-proceso": {
                backgroundColor: "#ff6105",
                textShadow: "2px 2px 2px 2px #ffffff",
                color: "white !important",
                "&:hover": {
                  backgroundColor: "rgb(27 33 54) !important", // Fondo al pasar el ratón
                },
              },
              "& .estado-default": {
                color: "gray",
                textShadow: "2px 2px 2px 2px #ffffff",
                "&:hover": {
                  backgroundColor: "rgb(27 33 54) !important", // Fondo al pasar el ratón
                },
              },
            }}
          >
            <DataGrid
              rows={data}
              getRowId={(row) => `${row.id}`}
              columns={columns}
              getRowClassName={getRowClassName} // Aplicar la clase condicional
              disableMultipleSelection
              onRowDoubleClick={handleRowDoubleClick}
            />
          </Box>

          <Box
            sx={{
              background: "rgb(36 43 67)",
              width: "100%",
              height: "48vh",
              marginTop: "-2.5vh",
              overflow: "auto",
              position: "relative", // Contexto para mantener separación
              zIndex: 1, // Más bajo que el DataGrid
            }}
          >
            <Box height="200px" m="1px 0 0 0" sx={{ paddingTop: "1vh" }}>
              {/* <LineChart isDashboard={true} /> */}
              <ReporteLavadora />
            </Box>
          </Box>
        </Box>
      </Box>
      <ModalLavadoraStar
        open={isOpen}
        modalParse={dataParse}
        onClose={handleCloseModal}
        buttonEnabled={handleButtonStatus}
        order={handleOrderChange}
      />
      <ModalCharge isLoading={isLoading} />
       <ModalSuccess open={registrationSuccess} onClose={handleCloseModalS} />
      <ModalError
       open={registrationError}
       onClose={handleCloseModalError}
       error={error}
              />

      {/* Dialogo Visualizar Paquetes */}
      <Dialog
        open={openPaquetes}
        onClose={handleClosePaquetes}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            backgroundColor: '#131b34',
            border: '1px solid #2a324d',
            borderRadius: 2,
          },
        }}
      >
        <DialogTitle
          disableTypography
          sx={{
            px: 2,
            py: 1.5,
            borderBottom: '1px solid #2a324d',
            backgroundColor: '#1e263d',
          }}
        >
          <Typography variant="h6" sx={{ color: 'rgb(206, 220, 0)', fontWeight: 700 }}>
            {paquetesDialogTitle}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          {paquetesLoading ? (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 3 }}>
              <CircularProgress size={28} sx={{ mr: 2 }} />
              <Typography variant="body1" sx={{ color: '#fff' }}>Cargando paquetes...</Typography>
            </Box>
          ) : paquetesError ? (
            <Alert severity="error">{paquetesError}</Alert>
          ) : (
            <Box sx={{ height: '45vh', width: '100%' }}>
              <DataGrid
                rows={(Array.isArray(paquetesCaballete) ? paquetesCaballete : []).map((p, idx) => ({
                  id: p?.id ?? idx,
                  cod: p?.cod ?? '-',
                  cod_interno: p?.cod_interno ?? '-',
                  cantidad_entrada: (p?.cantidad_entrada ?? p?.cantidad ?? '-') ,
                  serie: p?.serie ?? '-',
                }))}
                columns={paquetesColumns}
                disableMultipleSelection
                density="compact"
                sx={{
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: colors.blueAccent[900],
                    borderBottom: 'none',
                  },
                  '& .MuiDataGrid-virtualScroller': {
                    backgroundColor: colors.primary[400],
                  },
                  '& .MuiDataGrid-footerContainer': {
                    backgroundColor: colors.blueAccent[900],
                    borderTop: 'none',
                  },
                  '& .MuiDataGrid-cell': { borderBottom: 'none' },
                  '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 600 },
                }}
              />
            </Box>
          )}
        </DialogContent>
      </Dialog>
      
    </Box>
  );
};

export default Lavadora;
